module.exports = __webpack_public_path__ + "static/media/surya.76804454.ogg";